var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exp-flex"},[_c('label',{staticClass:"exp-mob-heading d-flex align-items-center",attrs:{"id":"hideinlaptop"}},[_vm._v(" Expertise Level - "),_c('h3',{staticClass:"ml-3 text-capitalize",class:_vm.sliderValue == 0
					? 'text-yellow'
					: _vm.sliderValue == 1
					? 'text-orange'
					: _vm.sliderValue == 2
					? 'text-green'
					: _vm.sliderValue == 3
					? 'text-blue'
					: ''},[_vm._v(" "+_vm._s(_vm.inputData)+" ")])]),_c('div',{attrs:{"id":"hideinmobile"}},[_vm._m(0),_c('h3',{staticClass:"text-capitalize",class:_vm.sliderValue == 0
					? 'text-yellow'
					: _vm.sliderValue == 1
					? 'text-orange'
					: _vm.sliderValue == 2
					? 'text-green'
					: _vm.sliderValue == 3
					? 'text-blue'
					: ''},[_vm._v(" "+_vm._s(_vm.inputData)+" ")])]),_c('div',{staticClass:"slider-container position-relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sliderValue),expression:"sliderValue"}],staticClass:"slider",class:_vm.sliderClass,attrs:{"type":"range","min":"0","max":"3","step":"1"},domProps:{"value":(_vm.sliderValue)},on:{"input":_vm.handleInput,"click":_vm.handleSliderClick,"touchend":_vm.handleSliderClick,"__r":function($event){_vm.sliderValue=$event.target.value}}}),_c('div',{staticClass:"exp-line exp-line-1"}),_c('div',{staticClass:"exp-line exp-line-2"}),_c('div',{staticClass:"exp-line exp-line-3"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teams-label-font"},[_vm._v(" Expertise level"),_c('span',{staticClass:"asterik"},[_vm._v(" *")])])
}]

export { render, staticRenderFns }